import { FunctionComponent } from "react";
import { PageContainerProps } from "./page-container.types";

import * as S from "./page-container.styles";

import { ErrorBoundary } from "@/_old/components/error-boundary";
import { VisibleBreakpoint } from "@/_old/components/visible-breakpoint";
import { NO_SIDEBAR } from "@/_old/constants/no-sidebar";
import { AnalyticsProvider } from "@/_old/features/analytics";
import { ErrorAnalyticsProvider } from "@/_old/features/analytics/contexts/segment/error-segment";
import { DemoWarningBanner } from "@/_old/features/demo";
import { useLocation } from "react-router-dom";
import { ModalErrorRequest } from "../modal-error-request";
import { Sidebar } from "@/core/components/layout/sidebar";
import { SidebarInset, SidebarProvider } from "@/_old/components/ui/sidebar";
import { SidebarToggleResponsive } from "@/core/components/layout/sidebar/components/sidebar-toggle-responsive";
import { AuthProvider } from "@/core/components/auth/view/auth.provider";

export const PageContainer: FunctionComponent<PageContainerProps> = ({
  children,
}) => {
  const { pathname } = useLocation();

  const verifyPathSidebar = NO_SIDEBAR.includes(pathname);

  return (
    <S.Wrapper>
      <ErrorAnalyticsProvider>
        <ErrorBoundary
          fallback={(error) => <ModalErrorRequest error={error} />}
        >
          <AuthProvider>
            <AnalyticsProvider>
              <DemoWarningBanner />
              <S.ContainerContent css={{ height: `100vh` }}>
                <SidebarProvider>
                  {!verifyPathSidebar && <Sidebar />}

                  <S.MainContainer className="!p-0 overflow-x-hidden bg-tertiary">
                    <SidebarInset>
                      <VisibleBreakpoint breakpoint={"sm"} type="max">
                        <SidebarToggleResponsive />
                      </VisibleBreakpoint>

                      {children}
                    </SidebarInset>
                  </S.MainContainer>
                </SidebarProvider>
              </S.ContainerContent>
            </AnalyticsProvider>
          </AuthProvider>
        </ErrorBoundary>
      </ErrorAnalyticsProvider>
    </S.Wrapper>
  );
};
